import { OrganizationUnitCooperationSelection as OrganizationUnitCooperationSelectionType } from '../../../../../../types/Survey/Element'
import { OrganizationUnitCooperationSelection as OrganizationUnitCooperationSelectionAnalysisType } from '../../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'
import { Survey } from '../../../../../../types/Survey/Survey'

const OrganizationUnitCooperationSelection: React.FC<
  Props<OrganizationUnitCooperationSelectionType, OrganizationUnitCooperationSelectionAnalysisType> & {
    survey: Survey
    answerElement: OrganizationUnitCooperationSelectionAnalysisType
  }
> = ({ survey, element, answerElement }) => {
  const getUnitName = (uuid: string) => {
    return survey.context.organizationUnitList.find((u) => u.uuid === uuid)?.name || ''
  }

  return (
    <div>
      <Core element={element} />
      <div className="mt-3">
        <div className="flex flex-col mt-3 max-h-60 overflow-x-hidden overflow-y-auto">
          {answerElement.organizationUnitPrioSelectionList
            .sort((a, b) => a?.priority - b?.priority)
            .map((u) => (
              <div key={u.organizationUnitUUID}>{`${u.priority}. ${getUnitName(u.organizationUnitUUID)}`}</div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default OrganizationUnitCooperationSelection
